function slider() {
    /**
     * Examples slider
     */
    const sliderExamples = document.querySelector('.examples__slider');

    if(sliderExamples) {
        let slider = new Swiper(sliderExamples, {
            speed: 600,
            slidesPerView: 3,
            spaceBetween: 30,
            breakpoints: {
                1: {
                    slidesPerView: 1,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                1241: {
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            },
            pagination: {
                el: ".examples__pag",
                clickable: true,
            },
        });
    }


    /**
     * Flip content slider
     */
    const flipContentSlider = document.querySelectorAll('.flip-content__slider');

    if(flipContentSlider.length > 0 && window.innerWidth <= 1240) {
        flipContentSlider.forEach(el=> {
            let slider = new Swiper(el, {
                speed: 600,
                slidesPerView: 2.1,
                spaceBetween: 30,
                freeMode: true,
                breakpoints: {
                    1: {
                        slidesPerView: 1.2,
                        spaceBetween: 15,
                    },
                    768: {
                        slidesPerView: 2.1,
                        spaceBetween: 30,
                    },
                }
            });
        });
    }


    /**
     * Brands slider
     */
    const brandsSlider = document.querySelectorAll('.home__brands-slider');

    if(brandsSlider.length > 0) {
        brandsSlider.forEach(el=> {
            const reverseDirection = el.classList.contains('home__brands-slider--right');
        
            let slider = new Swiper(el, {
                speed: 5000,
                slidesPerView: 4,
                spaceBetween: 30,
                loop: true,
                breakpoints: {
                    1: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    768: {
                      slidesPerView: 4,
                      spaceBetween: 30
                    },
                },
                autoplay: {
                    delay: 1000,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                    reverseDirection: reverseDirection,
                },
            });
        })
    }


    /**
     * Company slider
     */
    const companySlider = document.querySelector('.company-slider')

    if (companySlider) {
        let slider = new Swiper(companySlider, {
            speed: 600,
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            autoplay: {
                delay: 3000,
            },
        });
    }


    /**
     * Documents slider
     */
    const sliderDocuments = document.querySelector('.documents-slider')

    if (sliderDocuments) {
        let slider = new Swiper(sliderDocuments, {
            speed: 600,
            slidesPerView: 4,
            spaceBetween: 30,
            navigation: {
                nextEl: '.documents-slider-nav-next',
                prevEl: '.documents-slider-nav-prev',
            },
            breakpoints: {
                1: {
                  slidesPerView: 2,
                  spaceBetween: 15
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 30
                },
                1241: {
                    slidesPerView: 4,
                }
            },
        });
    }
}

export default slider;